import { FETCH_USERS_ERROR,
				 NIL_ERROR,
				 USER_UNDELETABLE_ERROR,
				 MODAL_MESSAGE } from '../actions/types';

export default function(state = null, action) {
	switch (action.type) {
		case FETCH_USERS_ERROR:
			return action.payload;
		case USER_UNDELETABLE_ERROR:
			console.log("in error redcer, user undeletable");
			return action.payload;
		case NIL_ERROR:
			console.log("state in NIL_ERROR reducer:", state);
			return action.payload;
		case MODAL_MESSAGE:
			return action.payload;
		default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/reducers/errorReducer.js